let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("itKvn")).then(() => parcelRequire('fXwy5'));